import { useState } from 'react';

const navItems = ['头条', '热搜', '焦点', '热议', '升温'];

export default function TopMasthead() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [time, setTime] = useState('21:30');

  return (
    <header className="sticky top-0 z-40 border-b border-foreground-900/10 bg-background-50/90 backdrop-blur-md">
      <div className="border-b border-foreground-900/5 bg-background-100/60">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-1.5 text-[11px] tracking-wide text-foreground-600">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1.5 text-foreground-800">
              <i className="ri-sparkling-2-line text-primary-600"></i>
              实时热度追踪 · 数据每 5 分钟刷新
            </span>
          </div>
          <div className="hidden items-center gap-4 md:flex">
            <button
              onClick={() => setTime(new Date().toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }))}
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-foreground-600 transition-colors hover:text-foreground-900"
            >
              <i className="ri-time-line"></i>更新于 {time}
            </button>
            <a href="#subscribe" rel="nofollow" className="whitespace-nowrap transition-colors hover:text-foreground-900">
              订阅推送
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3">
        <button
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="菜单"
          className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-900/10 text-foreground-800 transition-colors hover:bg-foreground-50 md:hidden"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-lg`}></i>
        </button>

        <a href="#top" className="flex items-baseline gap-1.5">
          <span className="font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-[28px]">
            91黑料
          </span>
          <span className="hidden text-[11px] font-medium tracking-[0.3em] text-primary-600 sm:inline">HOT RANK</span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navItems.map((n, i) => (
            <a
              key={n}
              href={i === 0 ? '#top' : `#${['top', 'heat', 'focus', 'debate', 'rising'][i]}`}
              className="group relative whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-foreground-950"
            >
              {n}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary-500 transition-all duration-300 group-hover:w-full"></span>
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            aria-label="搜索"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-900/10 text-foreground-800 transition-colors hover:bg-foreground-50"
          >
            <i className="ri-search-line text-base"></i>
          </button>
          <button
            onClick={() => setMenuOpen(false)}
            className="hidden h-9 items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500 md:inline-flex"
          >
            <i className="ri-flashlight-line"></i>看新瓜
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="flex flex-col gap-1 border-t border-foreground-900/10 bg-background-50 px-4 py-3 md:hidden">
          {navItems.map((n, i) => (
            <a
              key={n}
              href={i === 0 ? '#top' : `#${['top', 'heat', 'focus', 'debate', 'rising'][i]}`}
              onClick={() => setMenuOpen(false)}
              className="rounded-md px-2 py-2 text-sm text-foreground-800 hover:bg-foreground-50"
            >
              {n}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}